<template>
  <div class="article-list-page">
    <SideBar
      :groups="groups"
      :isSidebarOpen="isSidebarOpen"
      @toggle-sidebar="toggleSidebar"
      @close-sidebar="closeSidebar"
      @handle-logout="handleLogout"
    />
    <div class="main-content">
      <TopBar
        :source="tag"
        @toggle-sidebar="toggleSidebar"
        @selected="getSelected"
      />
      <div class="content-area">
        <Breadcrumb
          :items="[
            { text: 'Dashboard', link: '/dashboard' },
            currentGroup
              ? { text: currentGroup.GroupName, link: null }
              : { text: 'IT Knowledge Base', link: null },
          ]"
        /><SectionContainer>
          <SectionHeader
            :title="
              currentGroup
                ? currentGroup.GroupName
                : 'IT Knowledge Base Categories'
            "
            :description="currentGroup ? currentGroup.GroupDescription : ''"
          />
          <div v-if="isLoading" class="loading-container">
            <LoadingSpinner size="medium" color="blue" />
          </div>

          <div v-else-if="articleGroups.length === 0" class="no-results">
            <i class="material-icons">info</i>
            <p>No article categories found.</p>
          </div>
          <div v-else class="group-grid">
            <div
              v-for="group in articleGroups"
              :key="group.GroupID"
              class="group-card-wrapper"
            >
              <div class="card hoverable group-card">
                <div class="card-content">
                  <h3 class="group-title">{{ group.GroupName }}</h3>
                  <p v-if="group.LinkName" class="link-name">
                    {{ group.LinkName }}
                  </p>
                  <div v-if="group.LinkDescription" class="link-description">
                    {{ group.LinkDescription }}
                  </div>
                  <div class="group-desc" v-if="group.GroupDescription">
                    {{ group.GroupDescription }}
                  </div>
                  <div class="card-action">
                    <button
                      class="btn blue white-text view-articles-btn"
                      @click="openArticleAction(group)"
                    >
                      <span class="btn-text">{{
                        group.HyperLink ? "View Details" : "View Articles"
                      }}</span>
                      <i class="material-icons btn-icon">{{
                        group.HyperLink ? "open_in_new" : "arrow_forward"
                      }}</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SectionContainer>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import config from "../config.js";
import SideBar from "./SideBar.vue";
import TopBar from "./TopBar.vue";
import AppFooter from "./AppFooter.vue";
import SectionContainer from "./SectionContainer.vue";
import SectionHeader from "./SectionHeader.vue";
import Breadcrumb from "./Breadcrumb.vue";
import LoadingSpinner from "./LoadingSpinner.vue";
import "../assets/css/dashboard.css";

export default {
  name: "ArticleList",
  components: {
    SideBar,
    TopBar,
    AppFooter,
    SectionContainer,
    SectionHeader,
    Breadcrumb,
    LoadingSpinner,
  },
  data() {
    return {
      articleGroups: [],
      groups: [],
      user: [],
      tag: [],
      isLoading: true,
      isSidebarOpen: false,
      usercookie: null,
    };
  },
  methods: {
    getToken() {
      return this.$cookies.get("arch-it-portal") || this.usercookie;
    },
    getArticleGroups() {
      this.isLoading = true;
      const token = this.getToken();
      const groupId = this.$route.params.groupId;

      // API endpoint changes based on whether we have a group ID
      const endpoint = groupId
        ? `group-content/${groupId}/30/show`
        : `group-content/1/30/show`;

      axios
        .get(
          config.getApiUrl(endpoint),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => {
          this.articleGroups = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching article groups:", error);
          this.isLoading = false;
        });
    },
    getGroups() {
      const token = this.getToken();

      axios
        .get(
          config.getApiUrl("group"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => {
          this.groups = response.data;
        });
    },
    getTag() {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("get-tag"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.tag = response.data));
    },
    getUser() {
      let params = new URLSearchParams();
      params.append("user", this.usercookie);
      const token = this.getToken();

      axios({
        method: "post",
        url: config.getApiUrl("get-user"),
        data: params,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      }).then((response) => {
        this.loginStatus(response.data);
      });
    },
    loginStatus(userData) {
      if (
        !userData ||
        !userData.expire ||
        Number(userData.expire) < Math.floor(Date.now() / 1000)
      ) {
        router.push({
          name: "Login",
        });
      }
    },
    handleLogout() {
      this.$cookies.remove("arch-it-portal");
      router.push({
        name: "Login",
      });
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      document.body.style.overflow = this.isSidebarOpen ? "hidden" : "";
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.body.style.overflow = "";
    },
    getSelected(result) {
      window.open(result.value, "_blank");
    },    openArticleAction(group) {
      console.log("Opening article action for group:", JSON.stringify(group, null, 2)); // Enhanced logging

      // If the article has a hyperlink, use that action
      if (group.HyperLink) {
        console.log("HyperLink found:", group.HyperLink);
        console.log("isExternal value:", group.isExternal);
        
        // Get the current groupId from the route or use the clicked group's parent ID if available
        const currentGroupId = this.$route.params.groupId || (group.ParentID || "1");
        
        // If HyperLink contains Google Drive link, navigate to ArticleDetail page with embed path
        if (group.HyperLink.includes("drive.google.com")) {
          console.log("Routing to ArticleDetailEmbed");
          // Check if we have LinkID (primary) or GroupID to use as the linkId
          const linkId = group.LinkID || group.GroupID;
          console.log(`Using groupId: ${currentGroupId}, linkId: ${linkId}`);
          router.push({
            name: "ArticleDetailEmbed",
            params: {
              groupId: currentGroupId,
              linkId: linkId,
            }
          });
        }        // If isExternal is "1", open in new tab
        else if (group.isExternal === "1") {
          console.log("Opening external link in new tab");
          window.open(group.HyperLink, "_blank");
        }
        // Otherwise, navigate to ArticleDetail page with external path
        else {
          console.log("Routing to ArticleDetailExternal");
          // Check if we have LinkID (primary) or GroupID to use as the linkId
          const linkId = group.LinkID || group.GroupID;
          console.log(`Using groupId: ${currentGroupId}, linkId: ${linkId}`);
          router.push({
            name: "ArticleDetailExternal",
            params: {
              groupId: currentGroupId,
              linkId: linkId,
            }
          });
        }      }
      // Otherwise navigate to the group's articles
      else {
        console.log("No HyperLink, routing to ArticleList");
        // Use GroupID or default to "1" if not available
        const groupId = group.GroupID || "1";
        console.log(`Routing to group with ID: ${groupId}`);
        
        router.push({
          name: "ArticleList",
          params: {
            groupId: groupId,
          },
        });
      }
    },
    viewGroupArticles(groupId) {
      router.push({
        name: "ArticleList",
        params: {
          groupId: groupId,
        },
      });
    },    openArticleDetail(group) {
      // Get the current groupId from the route or use the clicked group's parent ID if available
      const currentGroupId = this.$route.params.groupId || (group.ParentID || "1");
      
      // If HyperLink contains Google Drive link, navigate to ArticleDetail page
      if (group.HyperLink && group.HyperLink.includes("drive.google.com")) {
        const linkId = group.LinkID || group.GroupID;
        
        router.push({
          name: "ArticleDetailEmbed",
          params: {
            groupId: currentGroupId,
            linkId: linkId,
          }
        });
      }
      // If isExternal is "1", open in new tab
      else if (group.isExternal === "1" && group.HyperLink) {
        window.open(group.HyperLink, "_blank");
      }
      // Otherwise, navigate to ArticleDetail page
      else if (group.HyperLink) {
        const linkId = group.LinkID || group.GroupID;
        
        router.push({
          name: "ArticleDetailExternal",
          params: {
            groupId: currentGroupId,
            linkId: linkId,
          }
        });
      }
    },
    handleResize() {
      if (window.innerWidth > 768 && this.isSidebarOpen) {
        this.closeSidebar();
      }
    },
  },
  watch: {
    "$route.params.groupId": function (newGroupId, oldGroupId) {
      if (newGroupId !== oldGroupId) {
        this.getArticleGroups();
      }
    },
    "$route.query": function () {
      // This handles the case when we force-refresh with a query parameter
      if (this.$route.query._ && this.$route.name === "ArticleList") {
        this.getArticleGroups();
      }
    },
  },
  computed: {
    currentGroup() {
      if (!this.$route.params.groupId || !this.groups.length) return null;
      const groupId = this.$route.params.groupId;
      return this.groups.find(
        (group) =>
          group.GroupID === groupId || group.GroupID === parseInt(groupId)
      );
    },
  },
  created() {
    this.usercookie = this.$cookies.get("arch-it-portal");
    this.getUser();
    this.getGroups();
    this.getTag();
    this.getArticleGroups();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);

    // Listen for the custom refresh event from sidebar
    this.$root.$on("refresh-article-groups", this.getArticleGroups);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    // Clean up event listener
    this.$root.$off("refresh-article-groups", this.getArticleGroups);
  },
};
</script>

<style scoped>
.article-list-page {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #f5f5f5;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.no-results {
  text-align: center;
  padding: 40px 0;
  color: #757575;
}

.no-results i {
  font-size: 48px;
  color: #e0e0e0;
  margin-bottom: 16px;
}

.group-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 24px;
}

.group-card-wrapper {
  height: 100%;
}

.group-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 24px;
  overflow: hidden;
  height: 100%;
}

.group-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  cursor: pointer;
}

.group-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #00205b;
  margin: 0 0 10px 0;
}

.link-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #00205b;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
}

.link-description {
  color: #555;
  margin-bottom: 15px;
  font-size: 0.95rem;
  line-height: 1.5;
  min-height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
}

.group-desc {
  color: #555;
  margin-bottom: 20px;
  font-size: 0.95rem;
  line-height: 1.5;
  min-height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
}

.card .card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-action {
  padding-top: 15px;
  border-top: 1px solid #eaeaea;
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.card .card-action {
  padding: 10px 0px;
}

.card-action .btn {
  transition: all 0.3s ease;  position: relative;
  overflow: hidden;
  padding: 8px 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #1565c0 !important;
  cursor: pointer;
}

.card-action .btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  background-color: #1976d2 !important;
}

.view-articles-btn .btn-icon {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.view-articles-btn:hover .btn-icon {
  transform: translateX(4px);
}

.card-action .btn:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  transition: all 0.6s ease;
  z-index: 1;
}

.card-action .btn:hover:before {
  left: 100%;
  animation: shimmer 1.5s infinite;
}

.btn-text,
.btn-icon {
  position: relative;
  z-index: 2;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@media (max-width: 768px) {
  .group-grid {
    grid-template-columns: 1fr;
  }

  .card-action {
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ArticleList.vue